// src/components/MovieCard.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../styles/styles.css";

const MovieCard = ({ movie }) => (
  <Link to={`/movies/${movie.id}`} className="series-card">
    <div
      className="series-thumb"
      style={{ backgroundImage: `url(${movie.thumbnail})` }}
    >
      <div className="series-thumb-overlay" />
      <div className="series-title-hover">{movie.title}</div>
    </div>
    <div className="series-info">
      <h3 className="series-title">{movie.title}</h3>
      <p className="series-genre">{movie.genre.join(", ")}</p>
      <p className="series-release">Estreno: {movie.releaseDate}</p>
    </div>
  </Link>
);

export default MovieCard;